export interface ProgressivePollOptions<T> {
	getInterval?: (elapsedMs: number) => number
	timeout?: number
	isDone: (result: T) => boolean
}

export function progressivePoll<T>(
	fn: () => Promise<T>,
	options: ProgressivePollOptions<T>,
): Promise<T> {
	return new Promise((resolve, reject) => {
		const startTime = Date.now()

		const poll = async () => {
			try {
				const result = await fn()
				const elapsed = Date.now() - startTime

				if (options.isDone(result)) {
					resolve(result)
					return
				}

				if (options.timeout && elapsed >= options.timeout) {
					const err = new Error("Polling timeout")
					err.name = "PollingTimeoutError"
					reject(err)
					return
				}

				const nextInterval = options.getInterval?.(elapsed) || 5000
				setTimeout(poll, nextInterval)
			} catch (err) {
				reject(err)
			}
		}

		poll()
	})
}
